var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.66,26.19c1.25,6.04,1.25,12.43,0,18.47h-15.94c-1.21-6.05-1.19-12.42,0-18.47h15.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.84,44.69c1.13-6.11,1.13-12.41,0-18.53h8.11c3.05,5.37,3.05,13.15,0,18.53h-8.11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.53,26.16c-1.03,6.13-1.02,12.39,0,18.53h-8.11c-2.93-5.49-2.95-13.04,0-18.53h8.11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.84,47.85c-.82,3-3.37,9.06-7.05,9.07-3.98.02-6.59-5.74-7.26-9.07h14.32Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.84,23h-14.32c.66-3.33,3.28-9.09,7.26-9.07,3.53.02,6.28,6.13,7.05,9.07Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23c1.71-2.51,3.95-4.63,6.6-6.14.28-.16,4.11-2.09,3.93-1.54-1.63,2.33-2.48,5.05-3.47,7.69h-7.05Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.16,47.85c-2.39,3.78-6.37,6.47-10.53,8,.57-1.26,1.35-2.39,1.93-3.65s1.25-2.92,1.44-4.35h7.16Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.05,47.85c.98,2.65,1.87,5.33,3.47,7.69.05.15-.16.13-.32.11-2.22-.38-6.63-3.59-8.21-5.26-.62-.66-1.48-1.69-1.79-2.53h6.84Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.16,23h-7.16c-.18-1.43-.83-3.03-1.44-4.35s-1.36-2.39-1.93-3.65c4.17,1.56,8.1,4.2,10.53,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.6e99f349911e52be116921c8338ef80c.svg";
export { ForwardRef as ReactComponent };